module.exports = __webpack_public_path__ + "img/member-pic5.9bd20f9c.png";